
import { AsyncThunk, AsyncThunkConfig, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchByIdWithoutInputFactory } from "./fetchByIdFactory";
import { GET_STATION_CONFIGS, StationConfig, StationConfigResponse } from "../../Services/Agrisys_GqlDataCaller/StationCalls/queryStationConfigs";
import { Station } from "../../Services/Agrisys_GqlDataCaller/StationCalls/queryStations";

export const fetchStationConfigByStationIdsThunk = createAsyncThunk(
  `stationConfig/fetchByStationIds`,
  fetchByIdWithoutInputFactory<StationConfigResponse, StationConfig, Station["station_id"]>(GET_STATION_CONFIGS, (stationConfigResponse) => stationConfigResponse.data.station.configs)
) satisfies AsyncThunk<StationConfig[], number[], AsyncThunkConfig> as AsyncThunk<StationConfig[], number[], AsyncThunkConfig>